import { c as _c } from "react/compiler-runtime";
import { IcoPlusSmall16 } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import type { ReactNode } from 'react';
type AddSectionOverlayProps = {
  position: 'top' | 'bottom';
  children: ReactNode;
};

// Floats its add-buttons just outside the card's top or bottom border, revealed only on
// card hover, so unfilled slots reserve no layout space and never overlap card content.
// Stacks multiple buttons (e.g. rationale + note) without overlapping. The
// data-force-affordance ancestor hook pins them visible in hover-less Gallery stories.
export const AddSectionOverlay = t0 => {
  const $ = _c(5);
  const {
    position,
    children
  } = t0;
  const t1 = position === "top" ? "bottom-full" : "top-full";
  let t2;
  if ($[0] !== t1) {
    t2 = cx("absolute inset-x-0 z-10 flex flex-col items-center gap-1 py-2 opacity-0 transition-opacity", "pointer-events-none group-hover:pointer-events-auto group-hover:opacity-100 focus-within:pointer-events-auto focus-within:opacity-100", "in-data-force-affordance:pointer-events-auto in-data-force-affordance:opacity-100", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== t2) {
    t3 = <div className={t2}>{children}</div>;
    $[2] = children;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
type AddSectionButtonProps = {
  label: string;
  onClick: () => void;
};
export const AddSectionButton = t0 => {
  const $ = _c(4);
  const {
    label,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IcoPlusSmall16 color="tertiary" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== label || $[2] !== onClick) {
    t2 = <button type="button" className="flex items-center gap-1 rounded-full border border-tertiary bg-primary px-3 py-1 text-caption-1 text-tertiary shadow-sm outline-none transition-colors hover:bg-hover-control" onClick={onClick} onMouseDown={_temp}>{t1}{label}</button>;
    $[1] = label;
    $[2] = onClick;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(event) {
  return event.stopPropagation();
}